import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, colors } from 'theme'

const advertisementIds: IStyles = {
    wrapper: {
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        overflow: 'hidden',
        background: colors.white,
    },
    adIdHeader: {
        fontWeight: 700,
        borderTop: `1px solid ${colors.grey}`,
    },
    listWrapper: {
        position: 'relative',
    },
    checkbox: {
        display: 'flex',
        minWidth: 92,
    },
    handle: {
        marginRight: 20,
    },
    channelName: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: 40,
        width: '25%',
        minWidth: '60px',
        [mediaCSS.desktopML]: {
            width: '20%',

            [mediaCSS.desktopLM]: {
                marginLeft: 40,
                width: '15%',
            },
        },
    },
    scrollWrapper: {
        overflowY: 'hidden',
        overflowX: 'auto',
        width: '100%',
        minHeight: 'calc(100vh - 130px)',
        position: 'relative',
    },
    emptyList: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textTransform: 'uppercase',
        textAlign: 'center',
    },
    notFoundIcon: {
        marginBottom: 24,
    },
    changeButtons: {
        display: 'flex',
        position: 'absolute',
        right: 14,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0,
        transition: 'opacity 0.3s',

        '& >div': {
            marginLeft: 10,
        },
    },
    adId() {
        const self = this

        return {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${colors.grey}`,
            padding: 14,
            height: 70,
            overflow: 'hidden',
            lineHeight: 1.2,
            '&:hover': {
                [`& .${self.changeButtons}`]: {
                    opacity: 1,
                },
            },

            [mediaCSS.tab]: {
                paddingRight: 66,
            },
        }
    },
    searchBar: {
        display: 'flex',
        height: 40,
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        marginBottom: 14,
        background: colors.white,
    },
    search: {
        position: 'relative',
        width: '85%',

        [mediaCSS.tab]: {
            width: '70%',
        },
    },
    dropdown: {
        width: '15%',

        [mediaCSS.tab]: {
            width: '30%',
        },
    },
    searchInput: {
        border: 'none',
    },
    dropdownBtn: {
        button: {
            border: 'none',
            borderRadius: '0 !important',
            borderLeft: `1px solid ${colors.grey}`,
            background: 'none',
        },
    },
    checkboxItem: {
        backgroundColor: 'red',
    },
    deleteConfirmWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    deleteConfirm: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '340px',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        textAlign: 'center',
        padding: 34,
        borderRadius: 20,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '24px auto 0 auto',
        maxWidth: 210,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
    },
}

addStyles(advertisementIds)
export default advertisementIds
